<template>
    <div>
        <v-app-bar flat color="white" height="72" class="px-3" fixed app><h2>Audit Trail</h2> </v-app-bar>

        <v-container fluid class="pa-5">
            <v-row>
                <v-col>
                    <DataTable />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import DataTable from '@/components/AuditTrails/DataTable.vue';

export default {
    name: 'AuditTrails',
    components: {
        DataTable
    },
    data() {
        return {
            menu: false,
            confirmStatusLoading: false,
            formData: {},
            closeLoading: false
        };
    },
    methods: {
        initiate() {}
    },
    mounted() {
        this.initiate();
    }
};
</script>

<style lang="scss" scoped></style>
